import { OrderEditingTools } from "@redotech/redo-model/team";
import * as z from "zod";

const AllowedOrderEditTypesSchema_ = z.object({
  cancelOrder: z.boolean(),
  changeAddress: z.boolean(),
  updateOrder: z.boolean(),
  addOrderDiscount: z.boolean(),
  addOrderGiftNote: z.boolean(),
});

export const AllowedOrderEditTypesSchema: z.ZodType<AllowedOrderEditTypes> =
  AllowedOrderEditTypesSchema_;
export interface AllowedOrderEditTypes
  extends z.infer<typeof AllowedOrderEditTypesSchema_> {}

const OrderEditingSettingsSchema_ = z.object({
  cancelOrder: z.object({ enabled: z.boolean() }),
  updateOrder: z.object({
    enabled: z.boolean(),
    addItem: z.boolean(),
    removeItem: z.boolean(),
    changeVariant: z.boolean(),
  }),
  changeAddress: z.object({ enabled: z.boolean() }),
  addOrderDiscount: z.object({ enabled: z.boolean() }),
});

export const OrderEditingSettingsSchema: z.ZodType<OrderEditingSettings> =
  OrderEditingSettingsSchema_;
export interface OrderEditingSettings
  extends z.infer<typeof OrderEditingSettingsSchema_> {}

export const OrderEditingToolsDefault: OrderEditingTools = {
  cancelOrder: {
    enabled: false,
    cancelOrderTimeWindowAfterPlacingMinutes: 60 * 24,
    requireConfirmation: true,
  },
  changeAddress: {
    enabled: false,
    changeOrderAddressTimeWindowAfterPlacingMinutes: 60 * 24,
    requireConfirmation: true,
  },
  addOrderDiscount: {
    enabled: false,
    addOrderDiscountTimeWindowAfterPlacingMinutes: 60 * 24,
  },
  addOrderGiftNote: {
    enabled: false,
    addOrderGiftNoteTimeWindowAfterPlacingMinutes: 60 * 24,
  },
  updateOrder: {
    enabled: false,
    updateOrderTimeWindowAfterPlacingMinutes: 60 * 24,
    addItem: false,
    removeItem: false,
    changeVariant: false,
  },
};

export function teamHasAnOrderEditingToolEnabled(
  orderEditingTools: OrderEditingTools | undefined | null,
): boolean {
  if (!orderEditingTools) {
    return false;
  }
  return (
    (orderEditingTools.cancelOrder?.enabled ?? false) ||
    (orderEditingTools.changeAddress?.enabled ?? false) ||
    (orderEditingTools.addOrderDiscount?.enabled ?? false) ||
    (orderEditingTools.addOrderGiftNote?.enabled ?? false) ||
    (orderEditingTools.updateOrder?.enabled ?? false)
  );
}
